
    import '/Users/lijixiang/Work/power-design/site/docs/power-design/pro-form-upload.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-power-design-pro-form-upload-demo-pro-form-upload"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/Users/lijixiang/Work/power-design/site/docs/power-design/pro-form-upload.md?type=demo')
};